import { useCallback, useMemo, useState } from 'react'

import {
  Box,
  Button,
  Collapse,
  Divider,
  IconButton,
  Typography,
} from '@mui/material'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { message, Modal } from 'antd'

import { EAccountConnectionType, IAccount } from '../../../../../constants/chat'
import ImgTag from '../../../../../components/ImgTag'
import { FiPlus, FiTrash2 } from 'react-icons/fi'
import { isEmpty } from 'radash'
import { axiosInstance } from '../../../../../hooks/useAxios'
import { ERRORS_MESSAGE_MAPPER } from '../../../../../constants/errors'
import AssignUserModal from './AssignUserModal'

interface Props {
  account: IAccount
  platform: EAccountConnectionType
  mutate?: () => void
}
const AssignUserLists = (props: Props) => {
  const { account, mutate, platform } = props

  const [anchorEl, setAnchorEl] = useState(null)
  const [expanded, setExpanded] = useState(false)
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  const open = Boolean(anchorEl)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const handleDisconnect = useCallback(async (id: string) => {
    try {
      await axiosInstance.put(`/facebook/pages/disconnect/${id}`, {})
      mutate?.()
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }, [])

  const handleDeleteAccount = useCallback(
    async (id: string, platform: EAccountConnectionType) => {
      Modal.confirm({
        title: 'ยืนยันการทำรายการ',
        content: 'คุณต้องการลบข้อมูลนี้หรือไม่?',
        onOk: async () => {
          try {
            await axiosInstance.delete(
              `/${platform}/merchant/account/${id}`,
              {},
            )
            message.success('ลบข้อมูลสำเร็จ')
            mutate?.()
          } catch (e: any) {
            const messageError =
              ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
              'ลบข้อมูลไม่สำเร็จ'
            message.error(messageError)
          }
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    [],
  )

  const handleRemoveAssignUser = useCallback(
    async (username: string) => {
      try {
        await axiosInstance.post(`/facebook/pages/removeAssign/`, {
          pageId: account.objectId,
          usernames: [username],
        })
        mutate?.()
        message.success('ลบผู้ดูแลเพจสำเร็จ')
      } catch (e: any) {
        const messageError =
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
          'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
    },
    [account],
  )

  const canManage = useMemo(() => {
    // return platform === EAccountConnectionType.Facebook
    return false
  }, [platform])

  return (
    <>
      <AssignUserModal
        pageId={account.objectId ?? ''}
        name={account.name}
        isOpen={isPopupOpen}
        onClose={() => {
          setIsPopupOpen(false)
          mutate?.()
        }}
      />
      <Box id={account.objectId} display={'block'} sx={{ cursor: 'pointer' }}>
        <Box width={'100%'}>
          <Divider sx={{ my: 2 }} />
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={1}
            pl={2}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              onClick={toggleExpand}
            >
              {canManage && (
                <>{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</>
              )}
              <ImgTag imageUrl={account.image} name={account.name} size={35} />
              <Typography variant="body1">{account.name}</Typography>
            </Box>

            <Box display="flex" alignItems="center" gap={1}>
              {canManage && (
                <Button
                  variant="contained"
                  color="info"
                  size="small"
                  onClick={() => setIsPopupOpen(true)}
                  startIcon={<FiPlus />}
                >
                  เพิ่มผู้ดูแลเพจ ({account?.assigns?.length ?? 0})
                </Button>
              )}
              {/* <Typography variant="body2" color="success.main">
                {accountConnectionsStatusMap[account.status]}
              </Typography> */}
              <IconButton
                size="small"
                onClick={() =>
                  handleDeleteAccount(account?.objectId ?? '', platform)
                }
              >
                <FiTrash2 />
              </IconButton>
            </Box>
          </Box>
        </Box>
        {canManage && (
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box pl={6} width={'100%'}>
              {!isEmpty(account?.assigns) ? (
                account?.assigns?.map((assign, index) => (
                  <Box key={index}>
                    <Divider sx={{ my: 1 }} />
                    <Box display="flex" alignItems="center" mb={1} gap={2}>
                      <Box
                        display="flex"
                        alignItems="center"
                        sx={{
                          //responsive
                          '@media (min-width: 992px)': {
                            width: '20%',
                          },
                        }}
                        gap={1}
                      >
                        <Typography variant="body1">
                          {index + 1}. {assign}
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center">
                        <IconButton
                          size="small"
                          onClick={() => handleRemoveAssignUser(assign)}
                        >
                          <FiTrash2 />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                ))
              ) : (
                <Box width={'100%'} display={'flex'} justifyContent={'center'}>
                  ไม่พบผู้ดูแลเพจ
                </Box>
              )}
            </Box>
          </Collapse>
        )}
      </Box>
    </>
  )
}

export default AssignUserLists
